(() => {
  const roots = document.querySelectorAll("[data-gum-filters]");

  roots.forEach((root) => {
    const drawer = root.querySelector("[data-gum-drawer]");
    const openButtons = root.querySelectorAll("[data-gum-open-drawer]");
    const closeButtons = root.querySelectorAll("[data-gum-close-drawer]");

    if (drawer) {
      const openDrawer = () => {
        drawer.setAttribute("aria-hidden", "false");
        document.documentElement.style.overflow = "hidden";

        openButtons.forEach((button) => {
          button.setAttribute("aria-expanded", "true");
        });
      };

      const closeDrawer = () => {
        drawer.setAttribute("aria-hidden", "true");
        document.documentElement.style.overflow = "";

        openButtons.forEach((button) => {
          button.setAttribute("aria-expanded", "false");
        });
      };

      openButtons.forEach((button) => {
        button.addEventListener("click", openDrawer);
      });

      closeButtons.forEach((button) => {
        button.addEventListener("click", closeDrawer);
      });

      document.addEventListener("keydown", (event) => {
        if (event.key === "Escape") {
          closeDrawer();
        }
      });
    }

    // Delegated so inputs still auto-submit after the facet refresh below
    // replaces the form contents.
    root.addEventListener("change", (event) => {
      const input = event.target.closest("[data-gum-auto-submit]");

      if (input) {
        const form = input.closest("form");

        if (form) {
          form.submit();
        }
      }
    });

    // On unfiltered page loads the facet counts ignore stock (they only
    // reflect the filters in the URL). Fetch the availability-filtered
    // render of this section and swap in its filter forms so counts and
    // disabled options are stock-aware from the start.
    const params = new URLSearchParams(window.location.search);
    let hasFilterParam = false;

    params.forEach((value, key) => {
      if (key.startsWith("filter.")) {
        hasFilterParam = true;
      }
    });

    const section = root.closest(".shopify-section");

    if (!hasFilterParam && section) {
      const sectionId = section.id.replace("shopify-section-", "");
      const url = `${window.location.pathname}?filter.v.availability=1&section_id=${encodeURIComponent(sectionId)}`;

      fetch(url)
        .then((response) => (response.ok ? response.text() : Promise.reject()))
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, "text/html");

          root.querySelectorAll(".gum-filter-form").forEach((form) => {
            const fresh = doc.getElementById(form.id);

            if (fresh) {
              form.innerHTML = fresh.innerHTML;
            }
          });
        })
        .catch(() => {});
    }
  });
})();